
import { mapGetters } from "vuex";

import appReceiverConfiguration from "./app-receiver-configuration.vue";
import AppReceiverUserAccess from "./app-receiver-user-access.vue";
import AppRecieverSubscriptionPlan from "./app-reciever-subscription-plan.vue";
import AppRecieverPrinterSection from "./app-reciever-printer-section.vue";
import AppReceiverKotMarketing from "./app-receiver-kot-marketing.vue";

export default {
  components: {
    appReceiverConfiguration,
    AppReceiverUserAccess,
    AppRecieverSubscriptionPlan,
    AppRecieverPrinterSection,
    AppWhatsappConfiguration: () =>
      import("@/components/apps/app-whatsapp-configuration.vue"),
    AppReceiverKotMarketing
  },
  computed: {
    ...mapGetters("reciever", ["isWhatsappAdded"])
  }
};
